import { createContext, useState, useContext } from 'react';

type ListingContextType = {
    showDeleteModal: boolean;
    setShowDeleteModal: (show: boolean) => void;
    deletingListingId: string | number | null;
    setDeletingListingId: (id: string | number | null) => void;
}

const ListingContext = createContext<ListingContextType | undefined>(undefined);

export const useListingContext = (): ListingContextType => {
    const context = useContext(ListingContext);
    if (!context) {
        throw new Error('useListingContext must be used within a ListingProvider');
    }
    return context;
}

export const ListingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deletingListingId, setDeletingListingId] = useState<string | number | null>(null);

    return (
        <ListingContext.Provider value={{ showDeleteModal, setShowDeleteModal, deletingListingId, setDeletingListingId }}>
            {children}
        </ListingContext.Provider>
    );
}